import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidatorFn } from '@angular/forms';
import { Column } from '@miq/catalog';
import { DataObject } from '@shared/models/data-object.model';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { AbstractControlValidatorPlugin } from './control-validator-plugin-template';

export interface BaseColumnControlValidatorConfig extends DataObject {
  evaluateWhenChangesOn?: string[];
}

@Injectable({ providedIn: 'root' })
export class BaseColumnControlValidatorPlugin extends AbstractControlValidatorPlugin<Column> {
  /**
   * List of subscriptions made
   */
  subscriptions: Subscription[] = [];
  getSymbol(config: Column): symbol {
    return Symbol(`__BaseColumnControlValidatorPlugin_${config.columnId}`);
  }

  /**
   * Runs once, when control is not yet connected to the symbol, Wires configured validatorFns + last reviewed date and by to be both filled in or empty
   * it also sets up the listener on last reviewed by control to update date's validity
   * @param control
   * @param config
   */
  protected doConnect(control: AbstractControl, config: Column) {
    super.doConnect(control, config);

    // add listeners on other fields if configured
    const validatorConfig = config.validatorPluginConfig as BaseColumnControlValidatorConfig;
    if (validatorConfig?.evaluateWhenChangesOn?.length > 0) {
      // when input validity depends also on other control values provide a list of control names to listen to re-evaluate this control validity
      this._listenOtherFieldsAndUpdate(control, validatorConfig?.evaluateWhenChangesOn);
    }
  }

  private _listenOtherFieldsAndUpdate(control: AbstractControl, evaluateWhenChangesOn?: string[]) {
    const parent = control.parent;
    const otherControls = evaluateWhenChangesOn.map(ctrlName => parent.get(ctrlName)).filter(Boolean);

    const updateControlValidity = () => {
      control.updateValueAndValidity();
      if (control.invalid && control.pristine) control.markAsTouched();
    };
    otherControls.forEach(ctrl =>
      this.subscriptions.push(ctrl.valueChanges.pipe(distinctUntilChanged()).subscribe(updateControlValidity))
    );
  }

  disconnect() {
    this.subscriptions?.forEach(s => s.unsubscribe());
  }

  getValidators(config: Column): ValidatorFn[] {
    return config.validatorFns();
  }
  getAsyncValidators(_: Column): AsyncValidatorFn[] {
    return null;
  }
}
